import {
    Box,
    Button,
    Divider,
    Paper,
    Stack,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import { TReadBudgetsResponse } from "../../../../../services/budget/read-budgets";

type TUser = {
    id_e: string;
    avatar?: string;
    name?: string;
    role?: string;
    Role?: {
        name?: string;
    };
    hidden?: boolean;
    Sectors?: {
        id_e: string;
        name: string;
    }[];
    Permissions: string[];
    UserProcessProfiles?: {
        Profile: {
            abbreviation: string;
            name: string;
            id_e: string;
        };
    }[];
};

export type TActiviteProfileTypes = {
    color:
        | "#278027"
        | "#F28500"
        | "#DD04DD"
        | "#0B49EC"
        | "#9D0000"
        | "#03BA78"
        | "#0CB8B8"
        | "#FF015C"
        | "#9933FF"
        | "#824700"
        | "#800380"
        | "#4B07BF"
        | "#D14141"
        | "#8BB908"
        | "#333333";
    id_e: string;
    name: string;
    abbreviation: string;
}[];

type CollabsEquip = {
    projectTeam: TUser[];
    projectReviewer: TUser[];
    projectBiller: TUser[];
    dataBudgetById?: TReadBudgetsResponse;
    handleEditMode: () => void;
    activiteProfiles: TActiviteProfileTypes;
};

const CollabsEquip = ({
    projectTeam,
    projectReviewer,
    projectBiller,
    dataBudgetById,
    handleEditMode,
    activiteProfiles,
}: CollabsEquip) => {
    const isCreatedByBudget = !!dataBudgetById;

    const profiles = projectTeam.map((teamMember) => ({
        ...teamMember,
        isReviewer: projectReviewer.some(
            (reviewerData) => reviewerData.id_e === teamMember.id_e
        ),
    }));

    const TeamTable = () => {
        if (profiles.length)
            return (
                <TableContainer
                    sx={{
                        boxShadow: "unset",
                        backgroundColor: "transparent",
                    }}
                    component={Paper}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Time</TableCell>
                                <TableCell>Atuação</TableCell>
                                {isCreatedByBudget && (
                                    <TableCell>Perfil de atividade*</TableCell>
                                )}
                                <TableCell>Revisor</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {profiles.map((collaborator, i) => {
                                const findProfilesById =
                                    activiteProfiles?.filter((profile) =>
                                        collaborator.UserProcessProfiles?.some(
                                            (activiteProfile) =>
                                                activiteProfile.Profile.id_e ===
                                                profile.id_e
                                        )
                                    );

                                return (
                                    <>
                                        <TableRow key={collaborator.id_e}>
                                            <TableCell>
                                                <Typography>
                                                    {collaborator.name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {collaborator.role}
                                            </TableCell>
                                            {isCreatedByBudget && (
                                                <TableCell>
                                                    <Box display="flex" gap={1}>
                                                        {findProfilesById &&
                                                        findProfilesById?.length >
                                                            0 ? (
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                }}
                                                            >
                                                                {findProfilesById?.map(
                                                                    (
                                                                        profile,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <Box
                                                                                key={
                                                                                    profile.abbreviation
                                                                                }
                                                                                sx={{
                                                                                    display:
                                                                                        "flex",
                                                                                    alignItems:
                                                                                        "center",
                                                                                    justifyContent:
                                                                                        "center",
                                                                                    height: "2.5rem",
                                                                                    width: "2.5rem",
                                                                                    borderRadius:
                                                                                        "50%",
                                                                                    backgroundColor:
                                                                                        profile.color,
                                                                                    border: "2px solid #FFF",
                                                                                    marginLeft:
                                                                                        index ===
                                                                                        0
                                                                                            ? "0"
                                                                                            : "-0.5rem",
                                                                                    zIndex:
                                                                                        findProfilesById.length -
                                                                                        index,
                                                                                }}
                                                                            >
                                                                                <Typography
                                                                                    sx={{
                                                                                        color: "#FFF",
                                                                                        textAlign:
                                                                                            "center",
                                                                                        fontFamily:
                                                                                            "Noto Sans",
                                                                                        fontSize:
                                                                                            "0.75rem",
                                                                                        fontWeight: 600,
                                                                                        lineHeight:
                                                                                            "1.25rem",
                                                                                        letterSpacing:
                                                                                            "0.0088rem",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        profile.abbreviation
                                                                                    }
                                                                                </Typography>
                                                                            </Box>
                                                                        );
                                                                    }
                                                                )}
                                                            </Box>
                                                        ) : (
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    justifyContent:
                                                                        "center",
                                                                    height: "2.5rem",
                                                                    width: "2.5rem",
                                                                    borderRadius:
                                                                        "50%",
                                                                    backgroundColor:
                                                                        "#BDBDBD",
                                                                }}
                                                            >
                                                                <Divider
                                                                    sx={{
                                                                        backgroundColor:
                                                                            "#fff",
                                                                        width: "0.25rem",
                                                                        height: "0.125rem",
                                                                    }}
                                                                />
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            )}
                                            <TableCell>
                                                <Switch
                                                    checked={
                                                        collaborator.isReviewer
                                                    }
                                                    disabled
                                                    color="secondary"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            );

        return null;
    };

    const renderBillerTable = () => {
        if (projectBiller?.length)
            return (
                <TableContainer
                    sx={{
                        boxShadow: "unset",
                        backgroundColor: "transparent",
                    }}
                    component={Paper}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Faturador</TableCell>
                                <TableCell>Atuação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {projectBiller.map((biller) => (
                                <TableRow key={biller.id_e}>
                                    <TableCell>
                                        <Typography>{biller.name}</Typography>
                                    </TableCell>
                                    <TableCell>{biller?.Role?.name}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            );
        return null;
    };

    return (
        <Stack>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                    mb: "2.5rem",
                }}
            >
                <Button variant="contained" onClick={handleEditMode}>
                    Editar
                </Button>
            </Box>
            <Stack
                sx={{
                    gap: "2rem",
                }}
            >
                {TeamTable()}

                <div className="container-table">{renderBillerTable()}</div>
            </Stack>
        </Stack>
    );
};

export default CollabsEquip;
